module.exports = __webpack_public_path__ + "img/payroll01.2e98d6c4.jpeg";